// extracted by mini-css-extract-plugin
export default {"banner":"UiBanner_banner_VDF8L"};